import { ApiBase } from "@/api/ApiBase";

export class ConstantsApi extends ApiBase {}
